import React, {useState, useEffect,useRef} from 'react';
import {
  FlatList,
  SafeAreaView,
  StatusBar,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
  Dimensions, Animated
} from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { FontAwesome5 } from '@expo/vector-icons';
import Swal from 'sweetalert2'; 





const wait = timeout => {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
};

export default function admin({navigation,route}) {
const translateX = useRef(new Animated.Value(Dimensions.get("window").height)).current 
useEffect(()=>{
Animated.timing(translateX,{toValue:0,duration:2000}).start();
})
  const onRefresh = React.useCallback(() => {
    console.log('mais um log')
  
    wait(2000).then(() =>console.log('deu certo ')
    );
  }, []);
  onRefresh();
//set all variables 
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [offset, setOffset] = useState(1);
  const [id,setId] =React.useState('');
  useEffect(() => getData(), []);
  const Item = ({ item }) => (
    <Animated.View style={{transform:[{translateY:translateX}]}} >
      <View>
      {loading?(<ActivityIndicator color="white" size={40} />) : null}
     
      <View style={{flexDirection:'row',margin:20,borderBottomColor:'white',borderBottomWidth:0,backgroundColor:'dodgerblue'}}>
     <View style={{margin:20}}>
     <MaterialIcons name="monetization-on" size={40} color="white" />
     </View>
      <View style={{margin:20}}>
      <View style={{flexDirection:'row'}}>
      <Text style={{color:'white',fontSize:20,marginLeft:10}}>Troca de Saldo</Text>
      
      <TouchableOpacity style={{margin:20}} onPress={({})=>{
       Swal.fire({
       title: 'Dinheiro transferido?',
       text: "Tem certeza que esse valor já foi transferido",
       icon: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       cancelButtonText: 'Cancelar',
       confirmButtonText: 'Sim,Tenho certeza!'
       }).then((result) => {
       if (result.isConfirmed) {
       darBaixa(item.id);
       }
       })
       }}>
         <FontAwesome5 name="piggy-bank" size={30} color="white" />
       </TouchableOpacity>
      
    </View>
      <Text style={{color:'white',margin:10}}>Valor: {item.valor }</Text>
      <Text style={{color:'white',margin:10}}>Status: {item.status}</Text>
      <Text style={{color:'white',margin:10}}>Finalizado: {item.pago}</Text>
      <Text style={{color:'white',margin:10}}>V. T: {((item.valor)-(item.valor*15/100)).toFixed(2)}</Text>
      <Text style={{color:'white',margin:10}}>{item.datatime}</Text>
      </View>
      <Text style={styles.title}>{item.title}</Text>
      
      </View> 
      {/**/}  
 
      </View>
     
  
    </Animated.View>
  );
  


//pegar dados no servidor 
const getData = () => {
  setLoading(true);
  //Service to get the data from the server to render
  fetch(`https://emprestimoimperion.com/composer/controller/api/listartransacoescontas2.php`)
    //Sending the currect offset with get request
    .then((response) => response.json())
    .then((responseJson) => {
     // console.log(responseJson)
      //Successful response from the API Call
      setOffset(offset + 1);
      //After the response increasing the offset for the next API call.
      {if(dataSource.length != responseJson.length)
        { setDataSource([...dataSource, ...responseJson.dados]);
     // console.log(dataSource)
      
      }
      setLoading(false);
    }
      
    
    })
    .catch((error) => {
      console.error(error);
    });
    
};


//////////////////////////Dar baixa nos pedidos ////////////////

const darBaixa = (id) => {
    setLoading(true);
    //Service to get the data from the server to render
    fetch(`https://emprestimoimperion.com/composer/controller/api/darbaixa.php?id=${id}`)
      //Sending the currect offset with get request
      .then((response) => response.json())
      .then((responseJson) => {
      if(responseJson.statusCode=='200'){
        Swal.fire(
            'Atualizado!',
            'Atualizado com Sucesso.',
            'success'
          )
          setOffset(2)
      }else{

        Swal.fire(
        'Erro!',
        'Não atualizado.',
        'error'
        )
          
      }
      
      })
      .catch((error) => {
        console.error(error);
      });
      
  };







    //--------------------------------
  const [selectedId, setSelectedId] = useState(null);

  const renderItem = ({ item,adminid }) => {
  const backgroundColor = item.id === selectedId ? 'dodgerblue' : 'dodgerblue';
    return <Item item={item} onPress={() => setSelectedId(item.id)} style={{ backgroundColor }} />;
  };

  return (
    <SafeAreaView style={styles.container}>
      <FlatList
        data={dataSource}
        renderItem={renderItem}
        keyExtractor={item => item.id}
        extraData={selectedId}
       // onScroll={getData}
       />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: StatusBar.currentHeight || 0,
  },
  item: {
    padding: 20,
    marginVertical: 8,
    marginHorizontal: 16,
  },
  title: {
    fontSize: 20,
    color:'white',
    margin:5,
    borderRadius:16
  },
});